/* Klikmeting van de cadeaukaartbanners. Hoort bij snippets/cadeaukaart-banner.liquid. */
(function () {
  'use strict';
  if (window.__vckBannerMeting) return;
  window.__vckBannerMeting = true;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-vck-banner]') : null;
    if (!a) return;
    var plek = a.getAttribute('data-vck-banner') || 'onbekend';
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'cadeaukaart_banner', banner_plek: plek }); } catch (err) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'cadeaukaart_banner', { banner_plek: plek }); } catch (err) {}
  });
})();
